<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料类别">
              <a-tree-select
                v-decorator="['categoryIdList']"
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="例外类型">
              <global-select
                v-decorator="['exceptionTypeList']"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_EXCEPTION_TYPES', attribute1: 'Y' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '120px' } }">
          <a-row class="align-center">
            <a-button @click="handleExport" v-hasPermi="['scp:scpMrpExceptions:export']">导出</a-button>
            <a-col :md="7" :sm="24" class="ml50">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="计划运算完成时间">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1500 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PLAN_EXCEPTION_QUERY_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text }">
            <div :key="item.dataIndex">
              <span v-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpMrpExceptionsPlanExceptionsList, apiScpMrpCategoryCodeCategoryBox, apiScpMrpPlansCallMaterialPlanExecutionTime } from '@/api/scp/mrp-result-query/plan-exception-query'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  // eslint-disable-next-line
  name: 'Plan-exception-query', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {},
  data () {
    return {
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpExceptionsPlanExceptionsList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '例外类型',
          dataIndex: 'exceptionTypeName',
          align: 'center',
          width: 140,
          ellipsis: true,
          stickyFixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 140,
          ellipsis: true,
          stickyFixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '日期',
          dataIndex: 'newScheduleDate',
          scopedSlots: { customRender: 'newScheduleDate' },
          align: 'center',
          type: "text"
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          align: 'center'
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center'
        }
      ],
      treeData: [], // 物料类别
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "" // 计划运算完成时间
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  watch: {
    // 菜单和查询物料两个入口
    $route (to, from) {
      if (to.name !== "Plan-exception-query") {
        return
      }
      if (Object.keys(this.$route.query).length > 0) {
        this.goNextHandle()
      } else {
        this.$nextTick(() => {
          this.form.resetFields()
          this.$refs.dataTable.myDataSource = []
          this.$refs.dataTable.myPagination.total = 0
          this.dataCollectStartDate = ""
          this.planCompletionDate = ""
        })
      }
    }
  },
  created () {
    // 从查询物料页面跳转过来，带过来的数据自动填充
    if (Object.keys(this.$route.query).length > 0) {
      this.goNextHandle()
    }
  },
  mounted () {
    this.getSearchAllScheme()
  },
  methods: {
    goNextHandle () {
      const obj = JSON.parse(this.$route.query.data)
      const arr = []
      obj.plannerCode && arr.push(obj.plannerCode)
      obj.plannerCodeList = arr
      this.$nextTick(() => {
        this.form.setFieldsValue({
          planName: obj.planName,
          planVersion: obj.planVersion,
          organizationCode: obj.organizationCode,
          plannerCodeList: obj.plannerCodeList
        })
        this.onSearch()
      })
    },
    getTableTime () {
      // 数据收集时间、计划运算完成时间
      apiScpMrpPlansCallMaterialPlanExecutionTime(this.form.getFieldsValue()).then(res => {
        if (res.data) {
          this.dataCollectStartDate = this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.planCompletionDate = this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        }
      })
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      this.getTableTime()
      this.$refs.dataTable.searchParams = this.form.getFieldsValue();
      this.$refs.dataTable.getData();
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpExceptions/exportPlanExceptions', {
        ...this.form.getFieldsValue()
      }, `计划例外查询_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
</style>
